import CallHistoryRawItem from "./CallHistoryRawItem";

const CallHistoryRaw = ({history = [], callUuid}) => {
    return <div className="flex flex-row overflow-auto max-h-50 bg-gray-300 mb-1">
        {history.map((data, index) => <CallHistoryRawItem history={data}
                                                          id={callUuid + "_call_history_raw_" + index}
                                                          key={callUuid + "_call_history_raw_" + index}/>)}
    </div>
};
export default CallHistoryRaw;